import React from 'react'
import './styles.scss'
import listOfMaps from './chmaps-data.csv'

function chart(props) {
  return listOfMaps.map((m, index) => {
    return (
      <div className='column'>
        <div className='chmaps-wrapper' key={m.year + index}>

          <div className={'ranking-wrapper' + ' ' + m.color}>{m.ranking}.</div>

          <div className='shape'>
            <img
              src={require(`./img/map_${m.year}.png`)}
              alt=''
              className='ui fluid image'
            />
          </div>
          <div className='title-wrapper'>{m.yearName}</div>
        </div>
      </div>
    )
  })
}

export default chart
